import {
  REQUEST_SET_TRANSACTION,
  REQUEST_SET_CONTACT_TRANSACTION,
  RESET_STORE_TRANSACTION,
  REQUEST_SET_MISSION_TRANSACTION,
  REQUEST_SET_MISSION_VICTIM_EXPERTISE,
  REQUEST_SET_JUDICIARY_EXPERT_REPORT,
  REQUEST_SET_TRANSACTION_INBOXE_AREA,
} from 'containers/TransactionManagerTimeLine/constants';
import { fromJS } from 'immutable';

const initState = fromJS({
  transactions: [],
  contactTransaction: {},
  missionsTransaction: [],
  missionExpertises: [],
  judiciaryExpertReport: [],
  transactionInboxeAreaId: {},
});

const TransactionManagerTimeLineReducer = (state = initState, action: any) => {
  switch (action.type) {
    case REQUEST_SET_TRANSACTION:
      return state.set('transactions', fromJS(action.payload));
    case REQUEST_SET_CONTACT_TRANSACTION:
      return state.set('contactTransaction', fromJS(action.payload));
    case REQUEST_SET_MISSION_TRANSACTION:
      return state.set('missionsTransaction', fromJS(action.payload));
    case REQUEST_SET_MISSION_VICTIM_EXPERTISE:
      return state.set('missionExpertises', fromJS(action.payload));
    case REQUEST_SET_JUDICIARY_EXPERT_REPORT:
      return state.set('judiciaryExpertReport', fromJS(action.payload));
    case REQUEST_SET_TRANSACTION_INBOXE_AREA:
      return state.set('transactionInboxeAreaId', fromJS(action.payload));
    case RESET_STORE_TRANSACTION:
      return state
        .set('contactTransaction', fromJS({}))
        .set('missionsTransaction', fromJS([]))
        .set('missionExpertises', fromJS([]))
        .set('judiciaryExpertReport', fromJS([]))
        .set('transactionInboxeAreaId', fromJS({}));
    default:
      return state;
  }
};
export default TransactionManagerTimeLineReducer;
